import React from 'react';
import {
    LoginContainer,
    LoginContent,
    Clear,
    Form,
    Title,
    Submit,
    Logotipo,
    Center,
    Division,
    Message,
    FormDiv,
    Mobile,
    Hr,
    Flex
} from './styled';
import useForm from "../../hooks/useForm";
import Input from "../../components/Form/Input";
import {Link, Navigate} from "react-router-dom";
import Logo from '../../assets/svg/logo.svg';
import {UserContext} from '../../UserContext';
import Button from '../../components/Button';
import {Snackbar} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {AlertTitle} from '@material-ui/lab';
import { api } from '../../services/api';

const ForgotMyPassword: React.FC = () => {
    document.title = "Esqueci Minha Senha - Sultan Veste a Casa";

    const [sendEmail, setSendEmail] = React.useState(false);
    const [errorApi, setError] = React.useState('');

    const email = useForm('email');

    const {loading, error, login} = React.useContext(UserContext);

    React.useEffect(() => {
        if (error !== "") handleClick();
    }, [error]);

    async function submitForm(e: React.FormEvent) {
        e.preventDefault();

        if (email.validate()) {
            try{
                await api.post('password/email', {
                    email: email.value
                });

                setSendEmail(true);
            }catch(error){
                const result = (error as Error).message;
                setError(result);
            }
        }
    }
    

    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    if (login === true) return <Navigate to="/usuario"/>;

    return (
        <LoginContainer>
            <LoginContent>
                <Division>
                    <Flex>
                        <FormDiv>                            
                            {!sendEmail ?
                                <Form onSubmit={submitForm}>
                                    <Center>
                                        <Logotipo title="Logo da Sultan Veste a Casa" alt="Logo da Sultan Veste a Casa"
                                                  src={Logo}/>
                                    </Center>
                                    <Mobile>
                                        <Hr/>
                                    </Mobile>
                                    <Title>Digite seu E-mail</Title>
                                    <p className="bold">Você receberá um e-mail com um link para redefinir sua senha.</p>
                                    <Input required 
                                           autoComplete="off" id="email"
                                           type="text" {...email}
                                           placeholder="Entre com seu endereço de e-mail"
                                    />
                                    <Submit>
                                        <div>
                                            <Link title="Página de Login" to={`${process.env.PUBLIC_URL}/login`}>Página de Login</Link>
                                        </div>
                                        {loading ? <Button type="submit" disabled>Carregando...</Button> :
                                            <Button type="submit">Enviar</Button>}
                                    </Submit>
                                </Form>
                                :
                                <Alert severity="success">
                                    <AlertTitle>E-mail enviado com sucesso!</AlertTitle>
                                    Se o e-mail digitado existir em nossa base de dados, será enviado para ele um link
                                    para redefinir sua senha. <Link to={`${process.env.PUBLIC_URL}/login`}>Clique aqui </Link>
                                    para ir para a página de login.
                                </Alert>
                            }
                            <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
                                <Alert onClose={handleClose} severity="error">
                                    {error && error}
                                </Alert>
                            </Snackbar>                            
                        </FormDiv>
                    </Flex>
                    <Message>
                        <Logotipo title="Logo da Sultan Veste a Casa" alt="Logo da Sultan Veste a Casa" src={Logo}/>
                        <h1>Recuperação de Senha</h1>
                    </Message>
                    <Snackbar open={errorApi !== ''} autoHideDuration={3000} onClose={() => setError('')}>
                        <Alert onClose={() => setError('')} severity="error">
                            {errorApi && errorApi}
                        </Alert>
                    </Snackbar> 
                </Division>
                <Clear/>
            </LoginContent>
        </LoginContainer>
    );
};

export default ForgotMyPassword;